import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取批量信息
export const getOtherFee = data => {
  return axios.request({
    url: "/finance/zaf/hq/chargeDetail/index",
    method: "POST",
    data
  });
};

export const getWherehouse = data => {
  return axios.request({
    url: "/finance/zaf/hq/detail/warehouse",
    method: "GET",
    data
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/finance/zaf/hq/detail/read/${id}`,
    method: "GET"
  });
};
export const getConfig = () => {
  return axios.request({
    url: `/finance/zaf/hq/detail/config`,
    method: "GET"
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/zaf/hq/detail/update/${data.id}`,
    method: "PUT",
    data
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/zaf/hq/detail/save",
    method: "POST",
    data
  });
};

export const del = data => {
  return axios.request({
    url: "/finance/zaf/hq/detail/delete",
    method: "DELETE",
    data
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/finance/zaf/hq/detail/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const getFinance = (id) => {
  return axios.request({
    url: `/finance/zaf/hq/detail/getFinance/`+id,
    method: "GET"
  });
};

export const saveFinance = data => {
  return axios.request({
    url: "/finance/zaf/hq/detail/saveFinance/"+data.id,
    method: "POST",
    data
  });
};
export const getCharging = (params) => {
  return axios.request({
    url: `/finance/zaf/hq/detail/getCharging/`+params.id,
    method: "GET",
		params
  });
};

export const createBill = data => {
  return axios.request({
    url: "/finance/zaf/hq/chargeDetail/createBill",
    method: "POST",
    data
  });
};


export const getMultiRate = data => {
  return axios.request({
    url: "/finance/zaf/hq/chargeDetail/getBatchRate",
    method: "POST",
    data
  });
};

export const setBatchRate = data => {
  return axios.request({
    url: "/finance/zaf/hq/chargeDetail/setBatchRate",
    method: "POST",
    data
  });
};


export const recalculate = data => {
  return axios.request({
    url: "/finance/zaf/hq/chargeDetail/recalculate",
    method: "POST",
    data
  });
};